export default "__VITE_ASSET__BPIVjUSD__"